const Timer = () => {
  return (
    <div style={{background:"#FEDCE3", borderRadius:"40%", display:"flex", height:"78px", width:"78px",justifyContent:"center"}}>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer ring */}
      <circle cx="14" cy="14" r="13.1797" stroke="#D2042D" strokeWidth="1.64063" fill="none"/>
      
      {/* Inner arrow positioned at center - adjusted path for better positioning */}
      <path 
        d="M17.5 14.5L13.5 14.5L13.5 10.5C13.5 10.2239 13.2761 10 13 10C12.7239 10 12.5 10.2239 12.5 10.5L12.5 15.5C12.5 15.7761 12.7239 16 13 16L18 16C18.2761 16 18.5 15.7761 18.5 15.5C18.5 15.2239 18.2761 15 18 15L17.5 15L17.5 14.5Z" 
        fill="#D2042D"
        transform="rotate(0 14 14)" /* Rotate arrow 45 degrees */
      />
    </svg>
    </div>
  );
};
export default Timer;